module.exports = __webpack_public_path__ + "assets/img/world-news-network.7165271b.svg";